import React from 'react';
import { Box, Typography, useTheme, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const TERMS = [
  "Prix valide 30 jours.",
  "Nous ne sommes pas responsable des frais d'Hydro-Québec.",
  "Les interrupteurs et prises seront de type Decora.",
  "Les luminaires ainsi que leur installation ne sont pas inclus dans ce devis.",
  "Aucune main d'œuvre n'est incluse pour la supervision des coulées de béton.",
  "Le point de raccordement sur la maison devra se trouver à moins de 30 mètres du réseau Hydro-Québec."
];

const TermsAndConditions: React.FC = () => {
  const theme = useTheme();
  return (
    <Box>
      <List sx={{ pl: 1 }}>
        {TERMS.map((term, idx) => (
          <ListItem key={idx} disableGutters sx={{ alignItems: 'flex-start', py: 0.5 }}>
            <ListItemIcon sx={{ minWidth: 32, mt: 0.5 }}>
              <CheckCircleOutlineIcon fontSize="small" sx={{ color: theme.palette.primary.main, opacity: 0.7 }} />
            </ListItemIcon>
            <ListItemText
              primary={term}
              primaryTypographyProps={{
                variant: 'body2',
                color: 'text.secondary',
                sx: { lineHeight: 1.7 }
              }}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default TermsAndConditions; 